import { Icon } from '@/components/Icon';
import { ReactNode } from 'react';
import { TouchableOpacity, View } from 'react-native';
import { Text } from '@/components/Text';

type Props = {
  children: ReactNode;
  onStartPress: () => void;
};

export const AblenkerRadio = ({ children, onStartPress }: Props) => {
  return (
    <View className="flex-1 w-full items-center justify-evenly">
      <View className="w-11/12 flex flex-col justify-center items-center bg-slate-50 rounded-md p-2">
        <Text className="text-3xl text-center">Ablenker</Text>
        {children}
      </View>
      <TouchableOpacity
        activeOpacity={0.7}
        className="w-full items-center justify-center gap-y-1"
        onPress={onStartPress}
      >
        <Icon
          name="caretRight"
          className="text-green-neolexon scale-150 text-9xl"
        />
        <Text className="text-7xl">Start</Text>
      </TouchableOpacity>
    </View>
  );
};
